import * as React from "react";
import { Avatar, Menu, MenuItem } from "@progress/kendo-react-layout";
import {
    AppBar,
    AppBarSection,
    AppBarSpacer,
} from "@progress/kendo-react-layout";
import { Badge, BadgeContainer } from "@progress/kendo-react-indicators";
import { Popup } from "@progress/kendo-react-popup";
import Bot from "../pages/Bot";
import { Alert } from "./Alert";
import operator from '../assets/assistance.png'
import user from '../assets/user.png'
import { GetToken, GetUserName, GetSession } from "../components/Session";
import configData from "../config.json";
import {
    Notification,
    NotificationGroup,
} from "@progress/kendo-react-notification";
import { Fade } from "@progress/kendo-react-animation";
import { setMessageSession } from "../components/Session";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import logo from "../assets/logo.png";
let kendokaAvatar = "https://www.telerik.com/kendo-react-ui-develop/components/images/kendoka-react.png";


export const Header = (props) => {
    const { onButtonClick } = props;
    const [errorMessage, setErrorMessage] = React.useState("");
    const [warningMessage, setWarningMessage] = React.useState("");
    const [infoMessage, setInfoMessage] = React.useState("");
    const [supportMessage, setSupportMessage] = React.useState();
    //localStorage.setItem("Notifications", JSON.stringify([0,0,0,0] ));
    let savedIds = [0, 0, 0, 0];
    let ls = localStorage.getItem("Notifications");
    if (ls !== null) savedIds = JSON.parse(ls);
    const latestIds = React.useRef(savedIds);
    const latest = React.useRef([0,0,0,0]);
    const support = React.useRef();
    const [logsTitle, setLogsTitle] = React.useState();
    const [logData, setLogData] = React.useState([]);

    React.useEffect(() => {
        var baseUrl;
        const init = {
            method: "GET",
            accept: "application/json",
            headers: { "Authorization": "Bearer " + GetToken() },
        };
        baseUrl = configData.SERVER_URL + "apiV7/support/ViewMessage/" + savedIds[0];
//        CheckNotifications();
//        setInterval(CheckNotifications, 5000);
        fetch(baseUrl, init)
            .then((response) => response.json())
            .then((d) => {
                support.current = d;
                setSupportMessage(d.description);
            });
    }, []);

    const CloseMessage = (m) => {
        if (latest.current !== undefined && latest.current.length > 0) {
            let l = latest.current.find(obj => obj.level === m);
            if (l !== undefined) {
                let li = [...latestIds.current];
                switch (m) {
                    case "Error": li[1] = l.id; setErrorMessage(""); break;
                    case "Warning": li[2] = l.id; setWarningMessage(""); break;
                    case "Information": li[3] = l.id; setInfoMessage(""); break;
                }
                latestIds.current = li;
            }
            if (m === "Support") {
                let li = [...latestIds.current];
                li[0] = support.current.supportId;
                latestIds.current = li;
                setSupportMessage("");
            }
            localStorage.setItem("Notifications", JSON.stringify(latestIds.current));
        }
    }

    const NotificationClicked = (e) => {
        if (e === "Support") return;
        const init = {
            method: "GET",
            accept: "application/json",
            headers: { "Authorization": "Bearer " + GetToken() },
        };
        let url = configData.SERVER_URL + `apiv7/private/getlogsforlevel?level=${e}`;
        fetch(url, init).then((response) => response.json()).then((d) => {
            setLogsTitle(e + " Logs");
            let data = [];
            for (let i = 0; i < d.length; i++) {
                data.push({ "timeStamp": new Date(Date.parse(d[i].timeStamp)), "message": d[i].message });
            }
            setLogData(data);
        });
    }

    const CheckNotifications = () => {
        const init = {
            method: "GET",
            accept: "application/json",
            headers: { "Authorization": "Bearer " + GetToken() },
        };
        let url = configData.SERVER_URL + "apiv7/private/getrecentlogs";
        fetch(url, init).then((response) => response.json()).then((d) => {
            latest.current = d;
            if (d !== undefined && d.length > 0) {
                let l = d.find(obj => obj.level === "Error" && obj.id > latestIds.current[1]);
                setErrorMessage(l !== undefined ? l.message : "");
                l = d.find(obj => obj.level === "Warning" && obj.id > latestIds.current[2]);
                setWarningMessage(l !== undefined ? l.message : "");
                l = d.find(obj => obj.level === "Information" && obj.id > latestIds.current[3]);
                setInfoMessage(l !== undefined ? l.message : "");
            }
        });
    }

    return (
        <AppBar style={{ padding: "0px 10px", color: "white", background: "#021417" }}>
            <AppBarSection>
                <div className="menu-button">
                    <span className={"k-icon k-i-menu"} onClick={onButtonClick} />
                </div>
            </AppBarSection>
            <AppBarSpacer
                style={{
                    width: 400,
                    width: 1,
                }}
            />
            <AppBarSection>
                <img src={logo} alt="EZYweigh" style={{ maxHeight: "45px" }} />
            </AppBarSection>
            <AppBarSpacer
                style={{
                    width: 40,
                }}
            />
            {GetSession().SiteID !== 1 && <AppBarSection>
                <div>NMI S627</div>
            </AppBarSection>}
            <AppBarSpacer
                style={{
                    width: 80
                }}
            /><AppBarSection>
                <NotificationGroup>
                    <div className="row">
                        {errorMessage && <div className="col-md-3" style={{ width: "250px" }}>
                            <Notification closable={true} onClose={() => CloseMessage("Error")} key={{}} type={{ style: "error", }} style={{ width: 240 }}><div className="Notification" onClick={() => NotificationClicked("Error")}>{errorMessage}</div></Notification>
                        </div>}
                        {warningMessage && <div className="col-md-3" style={{ width: "250px" }}>
                            <Notification closable={true} onClose={() => CloseMessage("Warning")} type={{ style: "warning", }} style={{ width: 240 }}><div className="Notification" onClick={() => NotificationClicked("Warning")}>{warningMessage}</div></Notification>
                        </div>}
                        {infoMessage && <div className="col-md-3" style={{ width: "250px" }}>
                            <Notification closable={true} onClose={() => CloseMessage("Information")} key={{}} type={{ style: "success", }} style={{ width: 240 }}><div className="Notification" onClick={() => NotificationClicked("Information")}>{infoMessage}</div></Notification>
                        </div>}
                        {supportMessage && <div className="col-md-3" style={{ width: "250px" }}>
                            <Notification closable={true} onClose={() => CloseMessage("Support")} key={{}} type={{ style: "info", }} style={{ width: 240 }}><div className="Notification" onClick={() => NotificationClicked("Support")}>{supportMessage}</div></Notification>
                        </div>}
                    </div>
                    <div>{logsTitle && <Dialog title={logsTitle} onClose={() => setLogsTitle()} >
                        <div style={{ maxWidth: "800px", maxHeight: "550px" }}>
                            <Grid data={logData} >
                                <Column field="timeStamp" title="Time" editable={false} format="{0:d/MM/yy hh:mm}" width={"200px"} />
                                <Column field="message" title="Message" editable={false} />
                            </Grid></div>
                    </Dialog>}
                    </div>
                </NotificationGroup>
            </AppBarSection>
            <AppBarSpacer
                style={{
                    float: "right",
                }}
            />
            <AppBarSection>
                <Menu>
                    <MenuItem
                        render={() => {
                            return (
                                <Avatar type="image">
                                    <img
                                        src={user}
                                        alt="KendoReact Layout Kendoka Avatar"
                                    />
                                </Avatar>
                            );
                        }}
                    >
                        <MenuItem text="Account" url="/account" />
                        <MenuItem text="Settings" url="/settings" />
                        <MenuItem text="Task Board" url="/Todos" />
                        <MenuItem text="Change Password" url="/password" />
                        <MenuItem text={"Logout (" + GetUserName() + ")"} url="/Logout" />
                    </MenuItem>
                </Menu>
            </AppBarSection>
        </AppBar>
    );
};
